export enum AdditionalProductType {
	ONLY_MOBILES = "only-mobiles",
	SHARED_MOBILES = "shared-mobiles"
}
